module.exports = __webpack_public_path__ + "static/media/23.f616e2cd.mp3";